import React from 'react';
import Auth from 'src/layouts/Auth/Auth';
import { Images } from 'src/Tenants';
import { useAuth, UseAuthReturn } from './hooks/useAuth';
import { TwoFAForm } from './components/twoFaForm';
import { LoginForm } from './components/LoginForm';

export const SignIn: React.FC = () => {
  const {
    email,
    password,
    setEmail,
    setPassword,
    termsAndConditions,
    setTermsAndConditions,
    show2FA,
    twoFACode,
    setTwoFACode,
    errors,
    loading,
    submit,
    submitTwoFA,
  }: UseAuthReturn = useAuth();

  return (
    <Auth
      title="Sign In"
      backgroundImage={Images.signInImage}
      content={
        <>
          <div className="sign-in">
            {show2FA ? (
              <TwoFAForm
                twoFACode={twoFACode}
                setTwoFACode={setTwoFACode}
                submitTwoFA={submitTwoFA}
              />
            ) : (
              <LoginForm
                email={email}
                password={password}
                termsAndConditions={termsAndConditions}
                setEmail={setEmail}
                setPassword={setPassword}
                setTermsAndConditions={setTermsAndConditions}
                errors={errors}
                submit={submit}
                loading={loading}
              />
            )}
          </div>
        </>
      }
    />
  );
};
